
import Vue from 'vue'
import Vuex from 'vuex'


Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    value:{},
    dialogShow:false,
    uniId:'',
    isLogin:false,
    head:''
  },
  mutations: {
    changeValue (state,obj) {
      state.value=obj
    },
    setuniId(state,id){
      state.uniId=id
    },
    login(state,url){
      state.isLogin=true
      state.head=url
    },
    logOut(state){
      state.isLogin=false
      state.head=''
      state.uniId=''
    }
  }
})


export default store


// WEBPACK FOOTER //
// ./src/store/store.js